import Suggestions from "./Suggestions/Suggestions";
import { useSearch } from "../../Contexts/SearchContext";
import DOMPurify from "dompurify";
import "./SearchBar.scss";
import PopularSearchTerms from "./PopularSearchTerms/PopularSearchTerms";
import magnifyIcon from "../assets/search-icon.svg";
import closeIcon from "../assets/close-icon.svg";

const SearchBar = ({
  name,
  postSearchHandler,
  getSuggestionHandler,
  placeholderText,
}) => {
  const { state, dispatch } = useSearch();
  // context
  const {
    searchTerm,
    showSuggestions,
    suggestions,
    selectedFilters,
    componentElement,
    popularSearchTerms,
    searchBarHasFocus,
  } = state;

  // handles

  const isMobile = window.innerWidth <= 1024;

  const handleChange = ({ target }) => {
    const { name, value: searchTerm } = target;
    const sanitizedSearchTerm = DOMPurify.sanitize(searchTerm);
    dispatch({ type: "UPDATE_SEARCH_TERM", payload: sanitizedSearchTerm });
    dispatch({ type: "UPDATE_SEARCH_TERM_HAS_CHANGED", payload: true });
    dispatch({ type: "UPDATE_SHOW_SUGGESTIONS", payload: true });

    if (sanitizedSearchTerm.trim() !== "") {
      dispatch({ type: "UPDATE_SHOW_SUGGESTIONS", payload: true });
    } else {
      dispatch({ type: "UPDATE_SHOW_SUGGESTIONS", payload: false });
    }
    getSuggestionHandler(sanitizedSearchTerm);
  };

  if (isMobile) {
    if (showSuggestions) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }

  const handleSubmit = (event, suggestion) => {
    let currentSearchTerm = suggestion || searchTerm;
    event?.preventDefault();
    const url = new URL(window.location.href);
    let currentSearchParams = "";
    if (url.searchParams) {
      currentSearchParams = (" " + url.searchParams.valueOf()).slice(1);
    }

    if (currentSearchTerm && currentSearchTerm !== "null") {
      url.searchParams.set("search", currentSearchTerm);
    } else {
      url.searchParams.delete("search");
    }

    // only push if it changed
    if (url.searchParams && currentSearchParams != url.searchParams.valueOf()) {
      window.history.pushState({}, "", url.href);
    }

    dispatch({ type: "UPDATE_SHOW_SUGGESTIONS", payload: false });
    dispatch({ type: "UPDATE_SEARCH_TERM_HAS_CHANGED", payload: false });

    // if user is performing a blank search it will reset the page, but if filters are selected we need to search '*'
    if (currentSearchTerm === "" && selectedFilters.length > 0) {
      currentSearchTerm = "*";
    }

    const sanitizedSearchTerm = DOMPurify.sanitize(currentSearchTerm);
    postSearchHandler(sanitizedSearchTerm, dispatch);
    componentElement.querySelector("#product-finder-search-input")?.blur();
    dispatch({ type: "UPDATE_SHOW_RESULTS", payload: true });
  };

  const capitalize = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map(
        (strWord) =>
          strWord.substring(0, 1).toUpperCase() +
          strWord.substring(1, strWord.length)
      )
      .join(" ")
      .split("-")
      .map(
        (strWord) =>
          strWord.substring(0, 1).toUpperCase() +
          strWord.substring(1, strWord.length)
      )
      .join("-");
  };

  const handleSuggestionOrPopularSearchTerm = (selection) => {
    const searchField = document.getElementById("product-finder-search-input");
    selection = capitalize(selection);
    searchField.value = selection;
    searchField.blur();

    dispatch({ type: "UPDATE_SHOW_SUGGESTIONS", payload: false });
    dispatch({ type: "UPDATE_SEARCH_TERM", payload: selection });
    dispatch({ type: "UPDATE_SEARCH_TERM_HAS_CHANGED", payload: true });

    handleSubmit(null, selection);
  };

  const handleSearchBarClose = (event) => {
      
    dispatch({ type: "UPDATE_SEARCH_TERM", payload: '' });
    dispatch({ type: "UPDATE_SEARCH_PARAMS", payload: '' });
    dispatch({ type: "UPDATE_SELECTED_FILTERS", payload: [] });
    const url = new URL(window.location.href);
    url.searchParams.delete("search");
    
    window.history.pushState({}, "", url);
    
}

  return (
    <div className="cmp-product-finder__search-bar-section">
      <form className="form-group" onSubmit={handleSubmit}>
        <div className="cmp-product-finder__search-bar-input-container">
          <input
            autoComplete="off"
            className="form-control"
            id="product-finder-search-input"
            name={name}
            value={searchTerm}
            placeholder={placeholderText}
            onBlur={() => {
              dispatch({ type: "UPDATE_SHOW_SUGGESTIONS", payload: false });
              dispatch({ type: "UPDATE_SEARCH_BAR_HAS_FOCUS", payload: false });
            }}
            onChange={handleChange}
            onFocus={() => {
              //dispatch({ type: "UPDATE_SHOW_SUGGESTIONS", payload: true });
              dispatch({ type: "UPDATE_SEARCH_BAR_HAS_FOCUS", payload: true });
            }}
            type="text"
          />

          {isMobile ? (
            <>
              <button
                type="button"
                className="chi close-icon"
                tabIndex="0"
                role="button"
                aria-label="close search suggestions"
                onClick={handleSearchBarClose}
                onTouchStart={handleSearchBarClose}
              >
                <img src={closeIcon} alt="close Icon" />
              </button>

              <span
                className={`chi search-icon magnify ${
                  searchBarHasFocus ? "magnify-focused" : ""
                }`}
                onClick={handleSubmit}
                onTouchStart={handleSubmit} 

              >
                <img src={magnifyIcon} alt="Search Icon" />
              </span>
            </>
          ) : (
            <>
              <span
                className="close-icon-focused"
                onClick={handleSearchBarClose}
                onTouchStart={handleSearchBarClose}
              >
                <img
                  src={closeIcon}
                  alt="close Icon"
                  className="close-icon-img"
                />
              </span>

              <span
                className={`chi search-icon magnify ${
                  searchBarHasFocus ? "magnify-focused" : ""
                }`}
                onClick={handleSubmit}
              >
                <img src={magnifyIcon} alt="Search Icon" />
              </span>
            </>
          )}

          <span className="start-typing-text">Start typing</span>
        </div>
        {popularSearchTerms && (
          <PopularSearchTerms
            handlePopularSearchTerm={handleSuggestionOrPopularSearchTerm}
            popularSearchTerms={popularSearchTerms}
          />
        )}
        {showSuggestions && (
          <Suggestions
            handleSuggestion={handleSuggestionOrPopularSearchTerm}
            suggestions={suggestions}
            searchTerm={searchTerm}
          />
        )}
      </form>
    </div>
  );
};

export default SearchBar;